// Module
var code = "<div class=\"container\"><div ng-if=\"vm.service\"><crumbs></crumbs><header class=\"m-b-lg\"><h1 class=\"page-title\" layout=\"row\" layout-align=\"none center\"><div class=\"m-r-xs\" ng-bind=\"vm.service.name\"></div><span ng-bind=\"' - ' + vm.service.code\"></span></h1></header><uib-tabset><uib-tab index=\"$index\" heading=\"Questionnaire\" select=\"\"><questionnaires service=\"vm.service\"></questionnaires></uib-tab></uib-tabset></div></div>";
// Exports
var _module_exports =code;;
var path = 'app/views/services/detail/service-detail.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;